import EditButton from 'components/FrictionlessCheckout/PaymentReleaseFour/PaymentMethodList/CreditCardsList/EditButton/EditButton';

export default EditButton;
